import { createGlobalStyle } from 'styled-components';
import { colors, typography } from './colors';
import { media } from './breakpoints';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Roboto:wght@300;400;500;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    /* Prevent font size inflation on mobile */
    -moz-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
  }

  body {
    font-family: ${typography.fontFamily.primary};
    font-size: ${typography.fontSize.md};
    color: ${colors.text.primary};
    background-color: ${colors.background.default};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* Prevent horizontal overflow on mobile */
    overflow-x: hidden;

    ${media.sm} {
      font-size: ${typography.fontSize.sm};
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${typography.fontFamily.heading};
    font-weight: ${typography.fontWeight.semibold};
    line-height: 1.3;
    color: ${colors.text.primary};
  }

  h1 { font-size: ${typography.fontSize.h1}; }
  h2 { font-size: ${typography.fontSize.h2}; }
  h3 { font-size: ${typography.fontSize.h3}; }
  h4 { font-size: ${typography.fontSize.h4}; }
  h5 { font-size: ${typography.fontSize.h5}; }
  h6 { font-size: ${typography.fontSize.h6}; }

  ${media.sm} {
    h1 { font-size: ${typography.fontSize.h3}; }
    h2 { font-size: ${typography.fontSize.h4}; }
    h3 { font-size: ${typography.fontSize.h5}; }
    h4 { font-size: ${typography.fontSize.h6}; }
  }

  a {
    color: ${colors.primary.main};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${colors.primary.light};
    }
  }

  button {
    font-family: ${typography.fontFamily.primary};
    cursor: pointer;
    border: none;
    outline: none;
    transition: all 0.3s ease;
    /* Minimum touch target size for mobile */
    min-height: 32px;
  }

  input, textarea, select {
    font-family: ${typography.fontFamily.primary};
    font-size: ${typography.fontSize.md};
    outline: none;
    /* Prevent zoom on input focus in iOS */
    ${media.sm} {
      font-size: 16px;
    }
  }

  /* Ensure tables don't overflow containers */
  table {
    max-width: 100%;
  }

  /* Ensure images are responsive */
  img {
    max-width: 100%;
    height: auto;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.background.paper};
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.primary.main};
    border-radius: 4px;

    &:hover {
      background: ${colors.primary.light};
    }
  }

  /* Hide scrollbar on mobile for cleaner look */
  ${media.sm} {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
  }
`;

export default GlobalStyles;
